import { FC, useEffect, useState } from 'react';
import { onLCP, onINP, onCLS, Metric, onTTFB, onFCP } from 'web-vitals';
import { useAnalytics } from "./AnalyticsProvider"

interface WebpageAnalytics {
	pageLoadDetails?: object
}

const PageLoadTime = Date.now()

export const WebpageAnalytics : FC<WebpageAnalytics> = ({pageLoadDetails}) => {
	const {record} = useAnalytics()
	const [initialPageLoadDetails] = useState(pageLoadDetails)

	useEffect(() => {
		if(record) {
			let firstConfiguratorSession = undefined
			try {
				firstConfiguratorSession = window.localStorage.getItem("HadConfiguratorSession") == null
				window.localStorage.setItem("HadConfiguratorSession", "true")
			}
			catch {
				console.debug("No local storage access")
			}

			record(["Webpage", "PageLoad"], {...(initialPageLoadDetails ?? {}), url: location.origin + location.pathname, FirstConfiguratorSession: firstConfiguratorSession})

			const recordWebVital = (event: Metric) => {
				record(["Webpage", `WebVital_${event.name}`], {value: event.value})
			}
			
			onTTFB(recordWebVital);
			onCLS(recordWebVital);
			onINP(recordWebVital);
			onFCP(recordWebVital);
			onLCP(recordWebVital);

			const recordVisibility = () => {
				if(document.hidden) {
					record(["Webpage", "PageHidden"])
				}
				else {
					record(["Webpage", "PageVisible"])
				}
			}
			document.addEventListener("visibilitychange", recordVisibility)

			const ping = () => {
				record(["Webpage", "Ping"], {elapsedTime: Date.now() - PageLoadTime})
			}
			const pingInterval = setInterval(ping, 20 * 1000)

			return () => {
				clearInterval(pingInterval)
				document.removeEventListener("visibilitychange", recordVisibility)
			}
		}
	}, [record, initialPageLoadDetails])

	return null;
}